"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const API = {
    memberREST: (serviceId) => `/blockpass_console/v1/services/${serviceId}/roles`,
};
class ServiceMember {
    constructor(httpClient, config) {
        this._httpClient = httpClient;
        this._baseURL = config.baseURL;
    }
    /**
     * https://qa-console.blockpass.org/blockpass_console/v1/services/62467636340a771c11c6607f/roles
     * method: GET
     * res: {"status":"success","data":[{"username":"an23@dev.com","email":"an23@dev.com","avatar":"","isEnable2FA":false,"id":"624676216939f87257572f2e","role":"owner","services":[],"status":"active"},{"avatar":"img/Males/O01.png","username":"An Dang","email":"andq@blockpass.org","formattedKey":null,"isEnable2FA":false,"id":"5b582dc9905649001937d231","role":"reviewer","services":[],"status":"active"}]}
     */
    async getListMember(serviceId) {
        const res = await this._httpClient.get(API.memberREST(serviceId), {
            baseURL: this._baseURL,
        });
        const data = {
            result: null,
            paging: {
                page: 0,
                limit: 100,
                total: 0,
            },
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return data;
        }
        data.result = lodash_1.default.map(resBody, 'id');
        data.paging.total = resBody.length;
        data.entities = {
            members: lodash_1.default.reduce(resBody, (acc, curr) => {
                curr._id = curr.id;
                delete curr.id;
                acc[curr._id] = curr;
                return acc;
            }, {}),
        };
        return data;
    }
    /**
     * https://qa-console.blockpass.org/blockpass_console/v1/services/62467636340a771c11c6607f/roles
     * method: POST
     * payload: {"user_email":"an14@dev.com","service_role":"reviewer"}
     * res: {"status":"success","data":{}}
     */
    async inviteMember(serviceId, payload) {
        const parsedPayload = {
            user_email: payload.userEmail,
            service_role: payload.serviceRole,
        };
        await this._httpClient.post(API.memberREST(serviceId), parsedPayload, {
            baseURL: this._baseURL,
        });
        return {
            result: null,
            entities: {},
        };
    }
    /**
     * https://qa-console.blockpass.org/blockpass_console/v1/services/62467636340a771c11c6607f/roles
     * method: PUT
     * payload: {"user_id":"5b582dc9905649001937d231","service_role":"owner"}
     * res: {"status":"success","data":{"service_id":"62467636340a771c11c6607f","service_role":"owner","user_id":"5b582dc9905649001937d231"}}
     */
    async updateMemberRole(serviceId, payload) {
        const parsedPayload = {
            user_id: payload.userId,
            service_role: payload.serviceRole,
        };
        const res = await this._httpClient.put(API.memberREST(serviceId), parsedPayload, {
            baseURL: this._baseURL,
        });
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return data;
        }
        data.result = resBody.user_id;
        data.entities = {
            members: {
                [resBody.user_id]: resBody,
            },
        };
        return data;
    }
    /**
     * https://qa-console.blockpass.org/blockpass_console/v1/services/62467636340a771c11c6607f/roles
     * method: DELETE
     * payload: {"userId":"5b582dc9905649001937d231","serviceRole":"owner"}
     * res: {"status":"success","data":{}}
     */
    async removeMember(serviceId, payload) {
        await this._httpClient.delete(API.memberREST(serviceId), {
            baseURL: this._baseURL,
            data: payload,
        });
        return {
            result: null,
            entities: {},
        };
    }
}
exports.default = ServiceMember;
